<!-- 为什么选择羿畅 -->
<template>
    <div class="container">
        <div class="nav">
            <div class="tabs">
                <div
                    class="tab-item "
                    v-for="(item,index) in tabList"
                    :key="index"
                    :class="active === item.url ? 'active':''"
                    @click="handleTabClick(item)"
                >{{ item.label }}
                </div>
            </div>
        </div>
        <component :is="active"></component>
    </div>
</template>

<script>
import successCase from '@/views/choiceYC/successCase/successCase'
import productAdvantage from '@/views/choiceYC/productAdvantage/productAdvantage'
import technicalAdvantage from '@/views/choiceYC/technicalAdvantage/technicalAdvantage'
import serviceAdvantage from '@/views/choiceYC/serviceAdvantage/serviceAdvantage.vue'


export default {
    components: {
        successCase,
        productAdvantage,
        technicalAdvantage,
        serviceAdvantage
    },
    name: 'choiceYC',
    data() {
        return {
            active: 'successCase',
            tabList: [
                {label: '成功案例', url: 'successCase'},
                {label: '产品优势', url: 'productAdvantage'},
                {label: '技术优势', url: 'technicalAdvantage'},
                {label: '服务优势', url: 'serviceAdvantage'}
            ],
        }
    },
    //刷新或通过URL地址进入页面时，同步背景图和标题
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$nextTick(() => {
                vm.$bus.$emit('changePageTitleAndBackground', {page: 'choiceYC'})
            })
        })
    },
    mounted() {
        this.$bus.$on('selectSystem', page => this.active = page)
    },
    methods: {
        handleTabClick(item) {
            this.active = item.url
        }
    },
}
</script>

<style lang='scss' scoped>
.container {
    height: 100%;
    width: 100%;

    .nav {
        transform: translateY(-100%);
        color: #ffffff;
        background: rgba(0, 0, 0, 0.5);
        padding: 0 20%;


        .tabs {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .tab-item {
                cursor: pointer;
                width: 126px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .active {
                background: #1890ff;
            }
        }
    }

}

@media screen and (max-width: 800px) {
    .container {
        .nav {
            padding: 0;

            .tabs {
                .tab-item {
                    font-size: 14px;
                    height: 40px;
                }
            }
        }
    }
}
</style>
